export default () => `Bearer ${localStorage.getItem("token")}`
